import LBox, { LBoxProps } from "@components/LBox";
import LButton from "@components/LButton";
import { useAuthSheet } from "@components/modals/AuthModal/useAuthSheet";
import LText from "@components/LText";

type NotLoggedInProps = LBoxProps & {
  header: string;
  text: string;
};

const NotLoggedIn = ({ header, text, ...props }: NotLoggedInProps) => {
  const openAuthSheet = useAuthSheet();

  return (
    <LBox gap="s2" {...props}>
      <LText textAlign="center" variant="h1">
        {header}
      </LText>
      <LText textAlign="center" color="subText">
        {text}
      </LText>
      <LBox width="100%" mt="s2">
        <LButton
          onPress={openAuthSheet}
          sentryEventName="not_logged_in_continue"
          variant="authActive"
          label="TRY FOR FREE"
          width="100%"
        />
      </LBox>
    </LBox>
  );
};

export default NotLoggedIn;
